import React from 'react';
import { Avatar, Box, Typography, IconButton } from '@mui/material';
import { KeyboardArrowDown, Hotel as HotelIcon } from '@mui/icons-material';
import { getStaticFileUrl } from '../../../utils/staticUtils';
import { mobileShellHeaderSx } from './mobileAppTheme';
import {
  getMobileHotelPickerTriggerIconSx,
  getMobileHotelPickerTriggerSx,
} from '../../../utils/mobileHotelPickerLayout';

function formatHotelLocation(hotel) {
  if (hotel?.city && hotel?.country) return `${hotel.city}, ${hotel.country}`;
  return hotel?.city || hotel?.country || '';
}

export default function MobileAppHeader({
  selectedHotel,
  user,
  onHotelClick,
  onProfileClick,
  hotelPickerOpen = false,
  className,
  style,
}) {
  const initial = user?.username?.[0]?.toUpperCase() || 'U';
  const locationLabel = formatHotelLocation(selectedHotel);

  return (
    <Box
      component="header"
      className={className}
      style={style}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        pt: 'env(safe-area-inset-top)',
        px: 2,
        pb: 0.65,
        ...mobileShellHeaderSx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', mb: 0.65 }}>
        <Box
          component="img"
          src={getStaticFileUrl('topbar/logo_ed_dark.png')}
          alt="RoomNexa"
          sx={{ height: 40, width: 'auto', objectFit: 'contain' }}
        />
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
          }}
        >
          <IconButton
            onClick={(e) => onProfileClick?.(e)}
            aria-label="Account menu"
            sx={{
              color: '#e2e8f0',
              border: '1px solid rgba(255,255,255,0.08)',
              backgroundColor: 'rgba(0,0,0,0.45)',
              width: 40,
              height: 40,
              p: 0,
            }}
          >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: '#4ce1b6',
              color: '#04120e',
              fontSize: '14px',
              fontWeight: 600,
            }}
          >
            {initial}
          </Avatar>
          </IconButton>
        </Box>
      </Box>

      {selectedHotel ? (
        <Box sx={{ maxWidth: { xs: '100%', sm: 520, md: 560 }, mx: 'auto', width: '100%' }}>
          <Box
            onClick={(e) => onHotelClick?.(e)}
            sx={getMobileHotelPickerTriggerSx(hotelPickerOpen)}
          >
          <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, flex: 1 }}>
            <Box sx={getMobileHotelPickerTriggerIconSx()}>
              <HotelIcon sx={{ fontSize: 18 }} />
            </Box>
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                sx={{
                  color: '#f8fafc',
                  fontWeight: 700,
                  fontSize: '0.92rem',
                  lineHeight: 1.25,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {selectedHotel.name}
              </Typography>
              {locationLabel ? (
                <Typography
                  sx={{
                    color: 'rgba(148,163,184,0.92)',
                    fontSize: '0.72rem',
                    lineHeight: 1.2,
                    mt: 0.15,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {locationLabel}
                </Typography>
              ) : null}
            </Box>
          </Box>
          <KeyboardArrowDown
            sx={{
              color: '#94a3b8',
              ml: 1,
              transition: 'transform 0.2s ease',
              transform: hotelPickerOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </Box>
        </Box>
      ) : (
        <Box sx={{ maxWidth: { xs: '100%', sm: 520, md: 560 }, mx: 'auto', width: '100%' }}>
          <Box onClick={(e) => onHotelClick?.(e)} sx={getMobileHotelPickerTriggerSx(hotelPickerOpen)}>
          <Typography sx={{ color: '#fbbf24', fontSize: '0.85rem', fontWeight: 600 }}>
            Select a hotel to continue
          </Typography>
          <KeyboardArrowDown sx={{ color: '#94a3b8', ml: 1 }} />
        </Box>
        </Box>
      )}
    </Box>
  );
}
